import React from "react";
import { useParams, Link } from "react-router";
import { getStudioBySlug } from "./studioRegistry";
import "./studiosScreen.css";

/**
 * Thin router: reads :slug from the URL, looks up the registered Studio, and
 * mounts its component. Unknown slugs show a not-found state.
 */
export default function StudioDetailScreen() {
  const { slug } = useParams();
  const studio = getStudioBySlug(slug);

  if (!studio) {
    return (
      <div className="studio-not-found">
        <h2>Studio not found</h2>
        <p>
          There's no Studio registered with the slug <code>{slug}</code>.
        </p>
        <Link to="/studios" className="studio-back-link">
          ← Back to Studios
        </Link>
      </div>
    );
  }

  const StudioComponent = studio.component;
  return <StudioComponent studio={studio} />;
}
